module.exports = __webpack_public_path__ + "static/media/fleet5.4ca485c5.png";